export default function RecalculateBlocksIds(elements = []) {
    const _elements = Array.isArray(elements) ? elements : [elements];

    const counters = {};

    (function recursion(elements) {
        for (const element of elements) {
            if (element.id) {
                const id = element.id.replace(/-\d+$/, "");
                counters[id] = (counters[id] ?? 0) + 1;
                element.id = `${id}-${counters[id]}`;
            }

            if (Array.isArray(element.children) && element.children.length > 0) {
                recursion(element.children);
            }
        }
    })(_elements);

    return true;
}
